import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: localStorage.getItem("username"),
  refresh: localStorage.getItem("refreshToken"),
  access: localStorage.getItem("token"),
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const { name, refresh, access } = action.payload;
      state.name = name;
      state.refresh = refresh;
      state.access = access;
    },
    removeUser: (state) => {
      state.name = null;
      state.refresh = null;
      state.access = null;
    },
  },
});

export const { setUser, removeUser } = userSlice.actions;
export default userSlice.reducer;
